import {Navigate, Outlet, useLocation} from "react-router-dom";
import { useTokenCache } from "../contexts/TokenCache";

export function RequireAuth({ children, allowedRoles }) {
  const location = useLocation();
  const { authStatus, groups } = useTokenCache();

  if (authStatus !== "authenticated" || !allowedRoles.some((ele) => groups.includes(ele))) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  } else {
    <Outlet />;
  }
  return children;
}
